// removed by extract-text-webpack-plugin
module.exports = {"base":"TextPlate_base--2EsYi"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/TextPlate/TextPlate.scss
// module id = 2268
// module chunks = 11